@if (image) {
    <a [routerLink]="url" class="brand d-block">
        <img [src]="image" alt="logo" (error)="image = null" />
    </a>
}
